import { AccountSettingsApi, AccountStatusApi } from '../../../api/contentLibrary/models/account-status.api.model';

export class StorageSettingsModel {
    contentStorageLimitBytes: number;
    contentUsedBytes: number;

    constructor(apiModel?: AccountStatusApi) {
        if (apiModel) {
            this.contentStorageLimitBytes = Number(((apiModel.contentStorageLimitBytes || 0) / 1024 / 1024 / 1024).toFixed(3));
            this.contentUsedBytes = parseFloat(((apiModel.contentUsedBytes || 0) / 1024 / 1024 / 1024).toFixed(3));
        }
    }

    toApiModelStatus(): AccountStatusApi {
        return {
            contentStorageLimitBytes: Number((this.contentStorageLimitBytes * 1024 * 1024 * 1024).toFixed(3)),
            contentUsedBytes: Number((this.contentUsedBytes * 1024 * 1024 * 1024).toFixed(3))
        };
    }

    toApiModelSettings(): AccountSettingsApi {
        return {
            contentStorageLimitBytes: Number((this.contentStorageLimitBytes * 1024 * 1024 * 1024).toFixed(3))
        };
    }
}
